
import './styles.css';
// import InsaneTable from '../../component/insane-table';
import InsaneTableNoHttp from '../../component/insane-table-no-http';
import PopupAlert from '../../component/popup-alert';

//////////// REACT /////////////
import React from "react";
import { useHistory } from "react-router-dom";

//////////// REDUX | STORE | SERVICE /////////////
import { useDispatch } from 'react-redux';
import { HttpRequest } from '../../service/HttpRequest';
import { showLoad, dismissLoad } from '../../store/slice/loading';

function ProductionResultPDChecksheetSurveyTag(props) {
    const PARAM = props.location.state;
    const history = useHistory();

    const dispatch = useDispatch();
    const [alert, setAlert] = React.useState(false);
    const [filterStatus, setFilterStatus] = React.useState("");

    const [dataReq, setDataReq] = React.useState([]);
    const [dataTable, setDataTable] = React.useState([]);

    const [TagResultCount, setTagResultCount] = React.useState({
        normal: 0,
        abnormal: 0,
        total: 0,
        remark: 0,
    });

    const tableOption = {
        tableName: "Tag",
        className: "",
        search: [
            {
                reqName: "from",
                displayName: "Start Date",
                element: "datetime-local"
            },
            {
                reqName: "to",
                displayName: "End Date",
                element: "datetime-local"
            }
        ],
        mapTable: [
            { displayName: "Equipment ID", attName: "label_equipment", type: "text", form: { validate: true, enable: true, element: "input" } },
            // { displayName: "Group name"    , attName: "label_equipmentgroup", type: "text"         , form: { validate: true, enable: true, element: "input" } },
            { displayName: "Latitude", attName: "latitude", type: "text", form: { validate: true, enable: true, element: "input" } },
            { displayName: "Longitude", attName: "longitude", type: "text", form: { validate: true, enable: true, element: "input" } },
            { displayName: "Time", attName: "logtime", type: "datetime", form: { validate: true, enable: true, element: "input" } },
            { displayName: "Remark", attName: "remark", type: "text", form: { validate: true, enable: true, element: "input" } },
            // { displayName: "Step"          , attName: "step"                , type: "text"         , form: { validate: true, enable: true, element: "input" } },
            // { displayName: "Survey No."    , attName: "surveyno"            , type: "text"         , form: { validate: true, enable: true, element: "input" } },
            // { displayName: "Tag result No.", attName: "tagresultno"         , type: "text"         , form: { validate: true, enable: true, element: "input" } },
            { displayName: "Control Range", attName: "label_normalvalue", type: "text", form: { validate: true, enable: true, element: "input" } },
            { displayName: "Value", attName: "value_double", type: "text", form: { validate: true, enable: true, element: "input" } },
            { displayName: "Value Status", attName: "label_status", type: "status", form: { validate: true, enable: true, element: "input" } },
            { displayName: "Status", attName: "value_enum", type: "text", form: { validate: true, enable: true, element: "input" } }
            // { displayName: "Image"         , attName: "base64"              , type: "bt-view-image", form: { validate: true, enable: true, element: "input" } }
        ],
        action: [
            // {
            //     name: "Tag Result",
            //     mode: "page", /// page, modal, form
            //     option: {
            //         url: ""
            //     }
            // }
        ]
    }

    const optionAlert = {
        header: "Wraning !!",
        content: "Do you want to Approve Survey - " + PARAM.surveyno + "?",
        button: [
            {
                name: "Cancel",
                style: {
                    color: "#444",
                    background: "#FFF",
                    border: "none"
                },
                event: React.useCallback(() => {
                    setAlert(false);
                }, [])
            },
            {
                name: "Approve",
                style: {
                    color: "white",
                    background: "#5d58e0"
                },
                event: React.useCallback(() => {
                    let option = {
                        "surveyno": PARAM.surveyno
                    }
                    HttpRequest("/admin/pd/survey/approve", option).then(data => {
                        // console.log(data);
                        if (data.result === "OK") {
                            history.goBack();
                        }
                    });
                }, [history, PARAM.surveyno])
            }
        ]
    }

    function confirmApprove() {
        setAlert(true);
    }

    async function onRequest(state = "") {
        dispatch(showLoad());

        setDataReq([]);
        setDataTable([]);

        await HttpRequest("/admin/pd/tagresult/get", {
            "index": 0,
            "count": 0,
            "surveyno": PARAM.surveyno,
            "equipmentid": "",
            "attachsnapshot": true
        }).then(data => {

            // console.log("/admin/pd/tagresult/get --->", data);
            if (data.result === "OK") {
                setDataReq(data.tagresults);
                setDataTable(data.tagresults);
            }

        });

        dispatch(dismissLoad());
        // console.log("dataReq --> ", dataReq);
    }


    React.useEffect(() => {
        const controller = new AbortController();

        // console.log("ProductionResultPDSurveyTag ", PARAM);

        onRequest();

        return () => { controller.abort() };
    }, []);// eslint-disable-line react-hooks/exhaustive-deps

    React.useEffect(() => {
        const controller = new AbortController();
        let New_TagResultCount = { ...TagResultCount }

        if (PARAM.tagresult_normal) {
            New_TagResultCount.normal = PARAM.tagresult_normal;
        } else {
            let count = (dataReq.filter((_data) => _data.label_status === "NORMAL")).length;
            if (count > 0) { New_TagResultCount.normal = count }
        }

        if (PARAM.tagresult_abnormal) {
            New_TagResultCount.abnormal = PARAM.tagresult_abnormal;
        } else {
            let count = (dataReq.filter((_data) => _data.label_status === "ABNORMAL")).length;
            if (count > 0) { New_TagResultCount.abnormal = count }
        }

        if (PARAM.tagresult_total) {
            New_TagResultCount.total = PARAM.tagresult_total;
        } else {
            let count = dataReq.length;
            if (count > 0) { New_TagResultCount.total = count }
        }

        if (PARAM.tagresult_remark) {
            New_TagResultCount.remark = PARAM.tagresult_remark;
        } else {
            let count = (dataReq.filter((_data) => _data.remark !== "")).length;
            if (count > 0) { New_TagResultCount.remark = count }
        }

        setTagResultCount(New_TagResultCount);

        return () => { controller.abort() };
    }, [dataReq]);// eslint-disable-line react-hooks/exhaustive-deps

    React.useEffect(() => {
        const controller = new AbortController();

        if (filterStatus !== "") {
            let dataReqFiltered = [];

            if (filterStatus === "REMARK") {
                dataReqFiltered = dataReq.filter((_data) => _data.remark !== "");
            } else {
                dataReqFiltered = dataReq.filter((_data) => _data.label_status === filterStatus);
            }

            setDataTable(dataReqFiltered);
        } else {
            setDataTable(dataReq);
        }

        return () => { controller.abort() };
    }, [filterStatus]);// eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div className='content'>
            <PopupAlert state={alert} option={optionAlert} onClose={React.useCallback(() => { setAlert(false) }, [])}></PopupAlert>
            <div className='content-page pd-tag-result'>
                <div className='head-content-page'>
                    <div className={'box-summary success ' + (filterStatus === "NORMAL" ? "active" : "")} onClick={() => setFilterStatus("NORMAL")}>
                        <div className='value'>{TagResultCount.normal}</div>
                        <div className='toppic'>Normal</div>
                    </div>
                    <div className={'box-summary wait ' + (filterStatus === "ABNORMAL" ? "active" : "")} onClick={() => setFilterStatus("ABNORMAL")}>
                        <div className='value'>{TagResultCount.abnormal}</div>
                        <div className='toppic'>Abnormal</div>
                    </div>
                    <div className={'box-summary total ' + (filterStatus === "" ? "active" : "")} onClick={() => setFilterStatus("")}>
                        <div className='value'>{TagResultCount.total}</div>
                        <div className='toppic'>Total</div>
                    </div>
                    <div className={'box-summary process ' + (filterStatus === "REMARK" ? "active" : "")} onClick={() => setFilterStatus("REMARK")}>
                        <div className='value'>{TagResultCount.remark}</div>
                        <div className='toppic'>Remark</div>
                    </div>
                </div>
                <div className='head-content-page'>
                    Tag result of Survey - {PARAM.surveyno}
                    {
                        PARAM.approved ? <div style={{ color: "#1FD606", marginLeft: 30 }}>Approved</div> : (null)
                    }
                    <div style={{ flexGrow: 1 }}></div>
                    {
                        !PARAM.approved ? <button className="btn btn-primary" onClick={confirmApprove}>Approve Survey - {PARAM.surveyno}</button> : (null)
                    }
                </div>
                {/* <InsaneTable option={tableOption}></InsaneTable> */}

                <InsaneTableNoHttp
                    option={tableOption}
                    dataTable={dataTable}
                    limitRow={10}></InsaneTableNoHttp>
            </div>
        </div >);
}

export default ProductionResultPDChecksheetSurveyTag;